import { render, staticRenderFns } from "./pagemenu.vue?vue&type=template&id=36cceb88&scoped=true&"
import script from "./pagemenu.vue?vue&type=script&lang=js&"
export * from "./pagemenu.vue?vue&type=script&lang=js&"
import style0 from "./pagemenu.vue?vue&type=style&index=0&id=36cceb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cceb88",
  null
  
)

export default component.exports